const DEFAULT_TIMEOUT_MS = 20000;

export default async function fetchWithTimeout(url, options = {}, timeoutMs = DEFAULT_TIMEOUT_MS) {
    const abortCtrl = new AbortController();
    const timeout = setTimeout(() => abortCtrl.abort(), timeoutMs);

    try {
        return await fetch(url, {
            ...options,
            signal: abortCtrl.signal
        });
    } catch (ex) {
        if (ex.name === "AbortError") {
            throw new Error("Request timed out. Possible license server not stable.");
        }

        throw ex;
    } finally {
        clearTimeout(timeout);
    }
}
